<template>
    <div>
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <div class="form-group custom-datepicker">
                <date-picker
                    v-model="model"
                    v-validate="{
                        required: field.isRequired,
                    }"
                    class="form-control"
                    format="DD/MM/YYYY"
                    lang="en"
                    :disabled="loading"
                    :data-vv-name="field.label"
                    :class="{
                        'is-invalid': errors.has(field.label),
                    }"
                    :end-at="endAt"
                    @input="onInput"
                ></date-picker>
                <i
                    :class="[
                        {
                            'disable-input': false,
                        },
                        'icon-calendar',
                    ]"
                ></i>
            </div>
            <p v-if="note" class="tax-instruction">
                <i class="icon-error_outline"></i>
                <span>
                    {{ note }}
                </span>
            </p>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
import DatePicker from 'vue2-datepicker'

export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        DatePicker,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        /**
         *
         * @return {string}
         */
        note() {
            return this.field.note
        }, // End of note() method
        endAt() {
            if (this.field.key == 'basicInfo.dateOfBirth') {
                return new Date()
            }
            if (this.field.key == 'basicInfo.dateOfIncorporation') {
                return new Date()
            }
            return ''
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the value is updated
         *
         * @return {void}
         */
        onInput(newValue) {
            this.model = newValue
        }, // End of onInput() method
    }, // End of Component > mounted
}
</script>
